import { isValidRegionSlug } from './regionLocale';

/**
 * Strips the region-locale prefix (/us/, /de-en/, /global/) from a browser
 * path, yielding the internal route the proxy rewrites to.
 */
export function internalPathFromBrowserPath(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  const first = segments[0]?.toLowerCase();
  if (first && isValidRegionSlug(first)) {
    const rest = segments.slice(1).join('/');
    return rest ? `/${rest}/` : '/';
  }
  return pathname;
}

/** True for /shop, /us/shop/, /de-en/shop — first internal segment is `shop`. */
export function isShopInternalPath(pathname: string): boolean {
  const internal = internalPathFromBrowserPath(pathname);
  return internal.split('/').filter(Boolean)[0] === 'shop';
}
